// Blog.jsx
import React from "react";
import PhoneViewer from "./PhoneViewer";
import phoneImages from "./phoneImages";

export default function Blog() {
  return (
    <div className="blog-two-col">
      <aside className="blog-side">
        <PhoneViewer images={phoneImages} />
      </aside>

      <main className="blog-main">
        {/* NEW: heading lives outside the card */}
        <h1 className="blog-heading">Studio Notes</h1>
        <p className="blog-intro">Welcome to my tiny blog! Tap the Nokia screen
             to open photos fullscreen, or use the arrows to go next/previous.</p>

        <article className="blog-post">
          
          <h2>🚧 Work in progress 🚧</h2>
          <p className="wip-note"> I’ll drop finished pieces in the shop once they’re ready. Thanks for peeking! ✨
        
          </p>
        </article>
      </main>
    </div>
  );
}
